import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import config from "../../config";
import { toast } from "react-toastify";

export default function UploadDocModal({ show, onHide, purchaseOrderId, onUpload }) {
  const [file, setFile] = useState(null);
  const [docType, setDocType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.error("Please select a file");
      return;
    }

    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("purchaseOrderId", purchaseOrderId);
      formData.append("documentType", docType);

      await axios.post(`${config.API_BASE_URL}/po-docs`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Document uploaded");
      setFile(null);
      setDocType("");
      onUpload();
      onHide();
    } catch (err) {
      console.error("Upload error:", err);
      toast.error("Failed to upload document");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Form onSubmit={handleUpload}>
        <Modal.Header closeButton>
          <Modal.Title>Upload Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Document Type</Form.Label>
            <Form.Control
              type="text"
              value={docType}
              onChange={(e) => setDocType(e.target.value)}
              placeholder="e.g. Invoice, Packing Slip"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Select File</Form.Label>
            <Form.Control
              type="file"
              onChange={(e) => setFile(e.target.files[0])}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Uploading..." : "Upload"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
